import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateFormData } from '../Utils/helpers'

export default class ResellerStore extends FetchBase {
  @observable ordering = undefined
  @observable orderingBy = undefined

  @observable innerOrdering = undefined
  @observable innerOrderingBy = undefined

  @observable innerMostOrdering = undefined
  @observable innerMostOrderingBy = undefined

  @observable inActiveordering = undefined
  @observable inActiveorderingBy = undefined

  @observable inActiveinnerOrdering = undefined
  @observable inActiveinnerOrderingBy = undefined

  @observable inActiveinnerMostOrdering = undefined
  @observable inActiveinnerMostOrderingBy = undefined

  @observable activeResellerSearchText = ''
  @observable inActiveResellerSearchText = ''

  @observable resellerFilterActive = {}
  @observable resellerFilterInActive = {}

  @observable activeMin = []
  @observable activeMax = []
  @observable inactiveMin = []
  @observable inactiveMax = []

  @observable totalReseller = 0
  @observable totalinActiveReseller = 0

  @observable mediaCentricUsersLoader = true

  @observable resellerDropdown = []

  @observable addResellerLoader = false
  @observable addNewResellerLoader = false

  @observable resellerData = []
  @observable resellerOrganizationsData = []
  @observable resellertransactionsData = []

  @observable inActiveresellerData = []
  @observable inActiveresellerOrganizationsData = []
  @observable inActiveresellertransactionsData = []

  @observable resellerActivePageNo = DEFAULT_PAGE_START
  @observable resellerInActiveUsersPageNo = DEFAULT_PAGE_START

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setInnerOrdering = (value = undefined) => {
    this.innerOrdering = value
  }

  @action.bound
  setInnerOrderingBy = (value = undefined) => {
    this.innerOrderingBy = value
  }

  @action.bound
  setInnerMostOrdering = (value = undefined) => {
    this.innerMostOrdering = value
  }

  @action.bound
  setInnerMostOrderingBy = (value = undefined) => {
    this.innerMostOrderingBy = value
  }

  @action.bound
  setInactiveOrdering = (value = undefined) => {
    this.inActiveordering = value
  }

  @action.bound
  setInactiveOrderingBy = (value = undefined) => {
    this.inActiveorderingBy = value
  }

  @action.bound
  setInactiveInnerOrdering = (value = undefined) => {
    this.inActiveinnerOrdering = value
  }

  @action.bound
  setInactiveInnerOrderingBy = (value = undefined) => {
    this.inActiveinnerOrderingBy = value
  }

  @action.bound
  setInactiveInnerMostOrdering = (value = undefined) => {
    this.inActiveinnerMostOrdering = value
  }

  @action.bound
  setInactiveInnerMostOrderingBy = (value = undefined) => {
    this.inActiveinnerMostOrderingBy = value
  }

  @action.bound
  SetResellerActivePageNo = (value = DEFAULT_PAGE_START) => {
    this.resellerActivePageNo = value
  }

  @action.bound
  SetResellerInActivePageNo = (value = DEFAULT_PAGE_START) => {
    this.resellerInActiveUsersPageNo = value
  }

  @action.bound
  setResellerFilterActive = (values = {}) => {
    this.resellerFilterActive = values
  }

  @action.bound
  setResellerFilterInActive = (values = {}) => {
    this.resellerFilterInActive = values
  }

  @action.bound
  setActiveResellerSearchText = (value = '') => {
    this.activeResellerSearchText = value
  }

  @action.bound
  setInActiveResellerSearchText = (value = '') => {
    this.inActiveResellerSearchText = value
  }

  @action.bound
  generateActiveResellerFilters = () => {
    let tempGenerateResellerFilters = {}

    let keys = Object.keys(this.resellerFilterActive || {})
    for (let filter of keys) {
      if (this.resellerFilterActive[filter] !== undefined) {
        tempGenerateResellerFilters[filter] = this.resellerFilterActive[filter]
      }
    }
    this.activeResellerSearchText &&
      (tempGenerateResellerFilters['search'] = this.activeResellerSearchText)
    this.ordering && (tempGenerateResellerFilters['ordering'] = this.ordering)
    this.ordering && (tempGenerateResellerFilters['orderBy'] = this.orderingBy)

    this.innerOrdering &&
      (tempGenerateResellerFilters['organizationOrdering'] = this.innerOrdering)
    this.innerOrdering &&
      (tempGenerateResellerFilters['organizationOrderBy'] =
        this.innerOrderingBy)

    this.innerMostOrdering &&
      (tempGenerateResellerFilters['transactionOrdering'] =
        this.innerMostOrdering)
    this.innerMostOrdering &&
      (tempGenerateResellerFilters['transactionOrderBy'] =
        this.innerMostOrderingBy)

    return tempGenerateResellerFilters
  }

  @action.bound
  generateInactiveResellerFilters = () => {
    let tempGenerateResellerFilters = {}

    let keys = Object.keys(this.resellerFilterInActive || {})
    for (let filter of keys) {
      if (this.resellerFilterInActive[filter] !== undefined) {
        tempGenerateResellerFilters[filter] =
          this.resellerFilterInActive[filter]
      }
    }
    this.inActiveResellerSearchText &&
      (tempGenerateResellerFilters['search'] = this.inActiveResellerSearchText)
    this.inActiveordering &&
      (tempGenerateResellerFilters['ordering'] = this.inActiveordering)
    this.inActiveordering &&
      (tempGenerateResellerFilters['orderBy'] = this.inActiveorderingBy)

    this.inActiveinnerOrdering &&
      (tempGenerateResellerFilters['organizationOrdering'] =
        this.inActiveinnerOrdering)
    this.inActiveinnerOrdering &&
      (tempGenerateResellerFilters['organizationOrderBy'] =
        this.inActiveinnerOrderingBy)

    this.inActiveinnerMostOrdering &&
      (tempGenerateResellerFilters['transactionOrdering'] =
        this.inActiveinnerMostOrdering)
    this.inActiveinnerMostOrdering &&
      (tempGenerateResellerFilters['transactionOrderBy'] =
        this.inActiveinnerMostOrderingBy)

    return tempGenerateResellerFilters
  }

  @action.bound
  getFilters = () => {
    let tempgetFilters = {}
    if (this.ordering) {
      tempgetFilters['ordering'] = this.ordering
      tempgetFilters['orderBy'] = this.orderingBy
    }
    return tempgetFilters
  }

  @action.bound
  resellerActiveExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateActiveResellerFilters()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_RESELLER, {
        isActive: true,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resellerInactiveExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateInactiveResellerFilters()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_RESELLER, {
        isActive: false,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resellerActiveList = async (signal) => {
    try {
      this.mediaCentricUsersLoader = true

      let options = this.generateActiveResellerFilters() || {}
      this.resellerActivePageNo &&
        (options['pageNo'] = Math.max(this.resellerActivePageNo - 1, 0))

      this.activeResellerSearchText &&
        (options['search'] = this.activeResellerSearchText)

      let response = await this.post(
        API_ENDPOINTS.GET_RESELLER_DATA,
        {
          isActive: true,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.resellerData = response.data.resellerDetails
        this.resellerOrganizationsData = response.data?.organizations
        this.resellertransactionsData =
          response.data.organizations?.transactions
        this.totalReseller = response.data.total
        this.activeMin = response.data?.min
        this.activeMax = response.data?.max
        return true
      }
      this.resellerData = []

      return false
    } catch (err) {
      this.resellerData = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  resellerInactiveList = async (signal) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = this.generateInactiveResellerFilters() || {}
      options['pageNo'] = Math.max(this.resellerInActiveUsersPageNo - 1, 0)
      this.inActiveResellerSearchText &&
        (options['search'] = this.inActiveResellerSearchText)
      let response = await this.post(
        API_ENDPOINTS.GET_RESELLER_DATA,
        {
          isActive: false,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.inActiveresellerData = response.data.resellerDetails
        this.inActiveresellerOrganizationsData = response.data?.organizations
        this.inActiveresellertransactionsData =
          response.data.organizations?.transactions
        this.totalinActiveReseller = response.data.total
        this.inactiveMin = response.data?.min
        this.inactiveMax = response.data?.max
        return true
      }
      this.inActiveresellerData = []

      return false
    } catch (err) {
      this.inActiveresellerData = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  getResellerDropDown = async (signal) => {
    try {
      this.projectTeamLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_RESELLER_DROPDOWN,
        {},
        signal
      )
      if (response.status) {
        this.resellerDropdown = response.data
        return [response.status, response.data]
      }
      this.resellerDropdown = []
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTeamLoader = false
    }
  }

  @action.bound
  checkIfCompanyNameExists = async (value) => {
    try {
      let respone = await this.post(API_ENDPOINTS.CHECK_COMPANY_NAME_EXIST, {
        companyName: value,
      })
      if (respone?.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch {
      return [false, undefined]
    }
  }

  @action.bound
  deleteReseller = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_RESELLER, {
        id: id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  toggleReseller = async (id, statusActivate) => {
    const status = statusActivate ? false : true
    try {
      let response = await this.post(API_ENDPOINTS.STATUS_TOGGLE_RESELLER, {
        id: id,
        status,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addReseller = async (values) => {
    try {
      this.addNewResellerLoader = true

      let {
        commission,
        contactNumber,
        description,
        email,
        firstName,
        lastName,
        phoneExtension,
        profileImage,
        companyName,
      } = values

      // let formdatavalue = generateFormData(values)

      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_RESELLER,
        generateFormData({
          commission,
          contactNumber,
          description,
          email,
          firstName,
          lastName,
          phoneExtension,
          profileImage,
          companyName,
        })
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addNewResellerLoader = false
    }
  }

  @action.bound
  getReseller = async (id) => {
    try {
      this.addResellerLoader = true
      let response = await this.get(API_ENDPOINTS.GET_RESELLER_BY_ID, {
        id,
      })
      if (response.status) {
        this.actionItem = response?.data
        return [true, response.data]
      }
      this.actionItem = {}
      return [false, undefined]
    } catch (err) {
      this.actionItem = {}
      return [false, undefined]
    } finally {
      this.actionItemLoader = false
    }
  }

  @action.bound
  editReseller = async (id, values) => {
    try {
      this.addNewResellerLoader = true
      let {
        commission,
        contactNumber,
        description,
        email,
        firstName,
        lastName,
        phoneExtension,
        profileImage,
        companyName,
        deleteProfileImage,
      } = values
      let response = await this.postWithFormData(
        API_ENDPOINTS.EDIT_RESELLER,
        generateFormData({
          id,
          commission,
          contactNumber,
          description,
          email,
          firstName,
          lastName,
          phoneExtension,
          profileImage,
          companyName,
          deleteProfileImage,
        })
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addNewResellerLoader = false
    }
  }

  @action.bound
  deleteResellerPhoto = async (id) => {
    try {
      this.addResellerLoader = true
      let response = await this.postWithFormData(
        API_ENDPOINTS.EDIT_RESELLER,
        generateFormData({
          id,
          deleteProfileImage: true,
        })
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addResellerLoader = false
    }
  }

  @action.bound
  editResellerProfile = async (id, values = {}) => {
    try {
      this.addResellerLoader = true

      let response = await this.postWithFormData(
        API_ENDPOINTS.EDIT_RESELLER,
        generateFormData(id, { ...values })
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addResellerLoader = false
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.resellerFilterActive = {}
    this.resellerFilterInActive = {}
  }

  @action.bound
  resetStore = () => {
    this.activeResellerSearchText = ''
    this.inActiveResellerSearchText = ''
    this.resellerFilterActive = {}
    this.resellerFilterInActive = {}
    this.resellerData = []
    this.resellerActivePageNo = DEFAULT_PAGE_START
    this.resellerInActiveUsersPageNo = DEFAULT_PAGE_START
    this.resellerOrganizationsData = []
    this.resellertransactionsData = []
    this.totalReseller = 0
    this.totalinActiveReseller = 0
    this.mediaCentricUsersLoader = true

    this.activeMin = []
    this.activeMax = []
    this.inactiveMin = []
    this.inactiveMax = []

    this.ordering = undefined
    this.orderingBy = undefined

    this.innerOrdering = undefined
    this.innerOrderingBy = undefined

    this.innerMostOrdering = undefined
    this.innerMostOrderingBy = undefined

    this.inActiveordering = undefined
    this.inActiveorderingBy = undefined

    this.inActiveinnerOrdering = undefined
    this.inActiveinnerOrderingBy = undefined

    this.inActiveinnerMostOrdering = undefined
    this.inActiveinnerMostOrderingBy = undefined

    this.addResellerLoader = false
    this.resellerDropdown = []
  }
}
